// extracted by mini-css-extract-plugin
module.exports = {"container":"Divider_container__1Swso"};